module.exports = __webpack_public_path__ + "img/type3.d847b50a.png";